import React, { Fragment } from "react";
import PropTypes from "prop-types";
import SafeHTML from "../SafeHTML";
import style from '../../../scss/components/Products/Specifications';
import { Tab } from 'semantic-ui-react';
import 'semantic-ui-css/components/tab.min.css';
export default class Specifications extends React.Component {
    static propTypes = {
        specifications: PropTypes.arrayOf(PropTypes.shape({
            category: PropTypes.string,
            content: PropTypes.string
        }))
    };
    constructor(props) {
        super(props);
        this.state = { tabPanes: [], menuOpen: false };
    }
    componentDidMount() {
        this.populateTabPanes();
    }
    toggleMenu() {
        let isMenuOpen = this.state.menuOpen;
        let menu = document.querySelector('.spec-tabs .menu');//append/remove open class to menu div
        if (isMenuOpen)
            menu.classList.remove("open");
        else
            menu.classList.add("open");
        this.setState({ menuOpen: !isMenuOpen });

    }
    populateTabPanes = () => {
        let panes = [];
        this.props.specifications.map(function (objItem, index) {
            panes.push({
                menuItem: objItem.category,
                render: () => <Tab.Pane><SafeHTML>{objItem.content}</SafeHTML></Tab.Pane>,
            })
        });
        this.setState({ tabPanes: panes })
    }
    handleTabChange = (e, data) => {
        this.setState({ menuOpen: false });//hide opened menu upon navigation
        let menu = document.querySelector('.spec-tabs .menu');
        menu.classList.remove("open");
    }
    render() {
        return (
            <section className="spec-section">
                <div className="container">
                    <div className={"spec-tabs-head" + (this.state.menuOpen ? " open" : "")} onClick={() => this.toggleMenu()}>
                        <h3 className="spec-tabs-title">产品规格</h3>
                    </div>
                    <div className="spec-tabs">
                        <Tab onTabChange={this.handleTabChange} menu={{ fluid: true, vertical: true }} panes={this.state.tabPanes} />
                    </div>
                </div>
            </section>
        );
    }
}
